import {
    ListItemDecorator,
    Tab,
    tabClasses,
    TabList,
    TabPanel,
    Tabs,
    Skeleton,
} from "@mui/joy";
import { useState } from "react";
import { useResponsive } from "../../../../hooks";

interface INavigationTabs {
    tabList: ITabList[];
    loading?: boolean;
}

interface ITabList {
    name: string;
    icon: any;
    component: any;
}

export function NavigationTabs(props: INavigationTabs) {
    const { tabList, loading } = props;
    const { isMobile } = useResponsive();
    const [activeTab, setActiveTab] = useState(tabList[0].name);

    return (
        <Tabs
            value={activeTab}
            onChange={(_, value) => setActiveTab(value as string)}
            size="sm"
            sx={{ mt: 0, width: "100%" }}
        >
            <TabList
                sx={{
                    gap: 2,
                    position: "sticky",
                    bgcolor: "background.surface",
                    zIndex: 1001,
                    top: 0,
                    maxWidth: "100%",
                    overflowX: "auto",
                    [`&& .${tabClasses.root}`]: {
                        flex: "initial",
                        flexShrink: 0,
                        color: "text.secondary",
                        opacity: 0.7,
                        background: "transparent",
                        bgcolor: "transparent",
                        paddingLeft: 0.5,
                        paddingRight: 0.5,
                        paddingBottom: 1.5,
                        paddingTop: 1.5,
                        fontWeight: 600,
                        "&:hover": {
                            bgcolor: "transparent",
                        },
                        [`&.${tabClasses.selected}`]: {
                            color: "primary.plainColor",
                            fontWeight: 600,
                            opacity: 1,
                            "&::after": {
                                height: 2,
                                borderTopLeftRadius: 3,
                                borderTopRightRadius: 3,
                                bgcolor: "primary.500",
                            },
                        },
                    },
                }}
            >
                {tabList.map((tab: ITabList, index: number) => {
                    const isActive = activeTab === tab.name;
                    return (
                        <Tab
                            sx={{ ml: index === 0 ? 2 : 0 }}
                            key={tab.name}
                            value={tab.name}
                        >
                            <Skeleton
                                loading={loading}
                                variant="text"
                                width={isActive || !isMobile ? 80 : 24}
                            >
                                <ListItemDecorator>
                                    {tab.icon}
                                </ListItemDecorator>
                                {(!isMobile || isActive) && tab.name}
                            </Skeleton>
                        </Tab>
                    );
                })}
            </TabList>
            {tabList.map((tab: ITabList) => {
                return (
                    <TabPanel
                        key={tab.name}
                        value={tab.name}
                        sx={{ py: 2, px: 0, maxWidth: "100%", zIndex: 1 }}
                    >
                        {tab.component}
                    </TabPanel>
                );
            })}
        </Tabs>
    );
}
